import { Component, OnInit, HostListener } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-market',
  templateUrl: './market.component.html',
  styleUrls: ['./market.component.scss']
})
export class MarketComponent implements OnInit {

  text: string;
  readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http:HttpClient) { }

  ngOnInit() {
    // this.readFromFile('market').then((data) => {
    //   this.text = data;
    //   console.log(data);
    // });
    this.readFromApi('market');
  }

  readFromApi(fileName: string ) : void
  {
    const prms =  '"' + fileName + '"';
    this.http.post<FText[]>( environment.apiUrl + '/api/data/', prms, this.httpOptions).subscribe(result => {
      this.text = result[0].con;
    });
  }



  async readFromFile(fileName: string ): Promise<string>
  {
    const text =  await this.http.get('../../../assets/data/' + fileName + '.txt', {responseType: 'text'}).toPromise();
    return text;
  }

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
  }

}

interface FText {
  con: string;
}
